module.exports = __webpack_public_path__ + "components/flag/static/square/va-83ac2f63a77e54667294549588bc7a68.svg";